export interface SheetRowPositionChange {
  rowId: string;
  sectionId: string | null;
  sortOrder: number;
}

/** readRows нумерует исходные строки по рангу до группировки в секции и фильтра. */
export function sheetRowsInPositionOrder<T extends { sortOrder: number }>(rows: T[]): T[] {
  const sorted = [...rows].sort((a, b) => a.sortOrder - b.sortOrder);
  return sorted.every((row, index) => row === rows[index]) ? rows : sorted;
}
